<template>
  <div style="height:calc(100% - 60px);overflow: hidden">
    <list-role v-if="listRoleFlag" :listRoleFlag="listRoleFlag" @changeView = "changeView"></list-role>
    <edit-role v-else :listRoleFlag="listRoleFlag" @changeView = "changeView"></edit-role>
  </div>
</template>

<script>
import ListRole from './listRole'
import EditRole from './editRole'

export default {
  name: '',
  data() {
    return {
      listRoleFlag: true
    }
  },
  components: {
    ListRole, EditRole
  },
  // computed() { },
  mounted() {
  },
  methods: {
    changeView(flag) {
      this.listRoleFlag = flag
    }
  }
}
</script>
